import 'react-app-polyfill/ie9';
import configureStore from './store/configureStore';
import React from 'react';
import ReactDOM from 'react-dom';
import routes from './routes';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { renderRoutes } from "react-router-config";
import './assets/css/base.less';

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <div>{ renderRoutes(routes()) }</div>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
